import { Icon } from '@iconify/react'
import { FC, memo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSpeechRecognition } from 'react-speech-recognition'
import MermaidChart from 'src/components/common/MermaidChart'
import ReactMarkdown from 'react-markdown'

interface GoalsPopupCanvasProps {
  canvasResponse?: string | null
  canvasData?: string | null
}

const GoalsPopupCanvas: FC<GoalsPopupCanvasProps> = memo((props) => {
  const { canvasData, canvasResponse } = props
  const { t } = useTranslation()
  const { listening, ...speechApi } = useSpeechRecognition()
  const sessionCanvasResponse = localStorage.getItem(
    'goalSessionCanvasResponse',
  ) as string

  return (
    <div
      className="d-flex w-100 h-100 flex-column position-relative"
      style={{
        padding: '0 1rem 1rem 1rem',
      }}
    >
      <div className="d-flex py-2">
        <Icon
          height="24"
          icon="tabler:target-arrow"
          width="24"
          style={{
            marginRight: '0.2rem',
          }}
        />
        <h5
          style={{
            margin: 0,
          }}
        >
          {t('common.word.pathway')}
        </h5>
      </div>
      <div
        className="card-body "
        style={{
          height: '100%',
          overflow: 'auto',
          backgroundColor: '#ffffff',
          padding: '0 1rem 1rem 1rem',
        }}
      >
        {canvasData || sessionCanvasResponse ? (
          <MermaidChart chart={sessionCanvasResponse ?? canvasData} />
        ) : (
          canvasResponse && (
            <div style={{ whiteSpace: 'pre-line' }}>
              <ReactMarkdown>{canvasResponse}</ReactMarkdown>
            </div>
          )
        )}
      </div>
    </div>
  )
})

export default GoalsPopupCanvas
